"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorTypesForQuestionType = exports.operatorTypesForField = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const OperatorType_1 = __importDefault(require("./OperatorType"));
const QueryFieldKey_1 = require("@opsbase/lib-data-queryfield/QueryFieldKey");
function operatorTypesForField(field) {
    if ((field === null || field === void 0 ? void 0 : field.key) === QueryFieldKey_1.QueryFieldKey.ASSET_LASTSERVICEDATE) {
        return [OperatorType_1.default.BEFORE,
            OperatorType_1.default.AFTER];
    }
    switch (field === null || field === void 0 ? void 0 : field.fieldType) {
        case BasicFieldType_1.default.STRING:
            return [OperatorType_1.default.EQUAL];
        case BasicFieldType_1.default.NUMBER:
        case BasicFieldType_1.default.OP_SCORE:
        case BasicFieldType_1.default.OP_ISSUE_COUNTS:
        case BasicFieldType_1.default.TEMPERATURE:
            return [
                OperatorType_1.default.LESS_THAN,
                OperatorType_1.default.LESS_THAN_OR_EQUAL,
                OperatorType_1.default.GREATER_THAN,
                OperatorType_1.default.GREATER_THAN_OR_EQUAL,
                OperatorType_1.default.EQUAL,
                OperatorType_1.default.NOT_EQUAL,
                OperatorType_1.default.BETWEEN,
            ];
        case BasicFieldType_1.default.BOOLEAN:
        case BasicFieldType_1.default.OPDEF_ENABLED:
        case BasicFieldType_1.default.OP_ISADHOC:
        case StaticFieldType_1.default.OP_HASISSUES:
            return [OperatorType_1.default.IS_TRUE, OperatorType_1.default.IS_NOT_TRUE];
        case BasicFieldType_1.default.DATE:
            return [
                OperatorType_1.default.IS_EMPTY,
                OperatorType_1.default.EQUAL,
                OperatorType_1.default.NOT_EQUAL,
                OperatorType_1.default.BEFORE,
                OperatorType_1.default.AFTER,
                OperatorType_1.default.BETWEEN,
            ];
        case BasicFieldType_1.default.RELATED_MODEL:
        case StaticFieldType_1.default.ISSUE_DUESTATUS:
        case StaticFieldType_1.default.ISSUE_RESTIME:
        case StaticFieldType_1.default.ISSUE_FLAG:
        case StaticFieldType_1.default.ISSUE_STATUS:
        case StaticFieldType_1.default.ISSUE_TYPE:
        case StaticFieldType_1.default.OP_PASSSTATUS:
        case StaticFieldType_1.default.OP_STATUS:
        case StaticFieldType_1.default.OP_TYPE:
            return [OperatorType_1.default.EQUAL, OperatorType_1.default.NOT_EQUAL];
        case StaticFieldType_1.default.OP_GRADE:
        case StaticFieldType_1.default.ORG_STATUS:
        case StaticFieldType_1.default.STAFF_APPSTATUS:
        case StaticFieldType_1.default.TASK_STATUS:
        case StaticFieldType_1.default.TASK_TYPE:
        case StaticFieldType_1.default.USER_TYPE:
        case BasicFieldType_1.default.RELATED_USER:
        case BasicFieldType_1.default.RELATED_SPT:
            return [OperatorType_1.default.IS_EMPTY, OperatorType_1.default.EQUAL, OperatorType_1.default.NOT_EQUAL];
        default:
            return [];
    }
}
exports.operatorTypesForField = operatorTypesForField;
function operatorTypesForQuestionType(questionType) {
    switch (questionType) {
        case FormQuestionType_1.default.SPT:
        case FormQuestionType_1.default.ASSET:
        case FormQuestionType_1.default.LIST:
        case FormQuestionType_1.default.RATING:
            return [OperatorType_1.default.EQUAL, OperatorType_1.default.NOT_EQUAL];
        case FormQuestionType_1.default.CHECK:
            return [OperatorType_1.default.EQUAL];
        case FormQuestionType_1.default.NUMBER:
            return [
                OperatorType_1.default.LESS_THAN,
                OperatorType_1.default.LESS_THAN_OR_EQUAL,
                OperatorType_1.default.GREATER_THAN,
                OperatorType_1.default.GREATER_THAN_OR_EQUAL,
                OperatorType_1.default.EQUAL,
                OperatorType_1.default.NOT_EQUAL,
                OperatorType_1.default.BETWEEN,
            ];
        case FormQuestionType_1.default.DATETIME:
            return [
                OperatorType_1.default.EQUAL,
                OperatorType_1.default.NOT_EQUAL,
                OperatorType_1.default.BEFORE,
                OperatorType_1.default.AFTER,
                OperatorType_1.default.BETWEEN,
            ];
        default:
            return [OperatorType_1.default.EQUAL];
    }
}
exports.operatorTypesForQuestionType = operatorTypesForQuestionType;
